import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, ChangeDetectionStrategy, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import * as i1 from '@play/common';
import { CommonsComponentModule, CommonsLocationModule, CommonsErrorModule } from '@play/common';
import * as i2 from '@play/translate';
import { TranslationModule } from '@play/translate';

class LoginComponent {
    constructor(location) {
        this.location = location;
        this.oauthUrl = "/user/oauth2/login";
        this.returnUrl = encodeURIComponent(window.location.pathname);
        this.loginUrl = `${this.oauthUrl}?continue=${this.returnUrl}`;
    }
    ngOnInit() {
        setTimeout(() => {
            if (this.returnUrl) {
                this.location.go(this.loginUrl);
            }
        }, 10000);
    }
}
LoginComponent.ɵfac = function LoginComponent_Factory(t) { return new (t || LoginComponent)(i0.ɵɵdirectiveInject(i1.Location)); };
LoginComponent.ɵcmp = i0.ɵɵdefineComponent({ type: LoginComponent, selectors: [["user-login"]], decls: 10, vars: 10, consts: [[1, "c-user-login"], [1, "c-button", "c-button--gigantic", "c-button--primary", 3, "href"]], template: function LoginComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "article", 0);
        i0.ɵɵelementStart(1, "h1");
        i0.ɵɵtext(2);
        i0.ɵɵpipe(3, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "a", 1);
        i0.ɵɵtext(5);
        i0.ɵɵpipe(6, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "p");
        i0.ɵɵtext(8);
        i0.ɵɵpipe(9, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 4, "user-login:title"));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("href", ctx.loginUrl, i0.ɵɵsanitizeUrl);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 6, "user-login:button"));
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(9, 8, "user-login:subtitle"));
    } }, pipes: [i2.TranslatePipe], styles: [".c-user-login[_ngcontent-%COMP%]{background-color:var(--frozen-white);margin-bottom:1.5rem;border-radius:2px;box-shadow:0 2px 4px rgba(0,0,0,.1);display:flex;align-items:center;flex-flow:column nowrap;padding:2rem 0}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoginComponent, [{
        type: Component,
        args: [{
                selector: "user-login",
                templateUrl: "./login.component.html",
                styleUrls: ["./login.component.scss"],
                encapsulation: ViewEncapsulation.Emulated,
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i1.Location }]; }, null); })();

class UserLoginModule {
}
UserLoginModule.ɵfac = function UserLoginModule_Factory(t) { return new (t || UserLoginModule)(); };
UserLoginModule.ɵmod = i0.ɵɵdefineNgModule({ type: UserLoginModule });
UserLoginModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[CommonModule, CommonsComponentModule, CommonsLocationModule, CommonsErrorModule, TranslationModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(UserLoginModule, { declarations: [LoginComponent], imports: [CommonModule, CommonsComponentModule, CommonsLocationModule, CommonsErrorModule, TranslationModule], exports: [LoginComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UserLoginModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, CommonsComponentModule, CommonsLocationModule, CommonsErrorModule, TranslationModule],
                declarations: [LoginComponent],
                exports: [LoginComponent],
            }]
    }], null, null); })();

const loginTexts = {
    "user-login:title": "You need to be logged in to see this page",
    "user-login:button": "Login to continue",
    "user-login:subtitle": "You will be automatically redirected in 10 seconds",
};

/**
 * Generated bundle index. Do not edit.
 */

export { LoginComponent, UserLoginModule, loginTexts };
//# sourceMappingURL=play-user-login.js.map
